import React from 'react';
import { useTheme, DefaultTheme } from 'styled-components';

import { IconName, svgIconsConfig } from 'assets/icons';

export const Icon = ({
  name,
  size = 16,
  color = 'black_80',
  strokeWidth = 2,
  rotate,
  fillColor,
}: {
  name: IconName;
  size?: number;
  color?: keyof DefaultTheme['colors'];
  fillColor?: keyof DefaultTheme['colors'];
  strokeWidth?: number;
  rotate?: number;
}) => {
  const { colors } = useTheme();

  const IconComponent = svgIconsConfig[name].component;

  // Determine whether to use stroke or fill based on the existence of fill prop
  const iconProps = !!fillColor ? { fill: colors[fillColor] } : { stroke: colors[color] };

  return (
    <IconComponent
      style={{ transform: `rotate(${rotate}deg)` }}
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      {...iconProps}
    />
  );
};
